import { useEffect, useRef, useState } from 'react';

const useObserveNotifications = (notifications, isVisible) => {
  const containerRef = useRef(null);
  const [seenIds, setSeenIds] = useState([]);

  useEffect(() => {
    if (!isVisible || !containerRef.current) {
      setSeenIds([]);
      return;
    };

    const elements = containerRef.current.querySelectorAll('[data-id]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute('data-id');
          const isNew = entry.target.getAttribute('data-new');
          if (entry.isIntersecting && id && isNew === 'true' && !seenIds.includes(id)) {
            setSeenIds(prev => [...prev, id]);
          }
        });
      },
      { threshold: 0.8 }
    );

    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, notifications]);

  return { containerRef, seenIds };
};

export default useObserveNotifications;
